import type { SendNotificationRequestContentData } from './sendNotificationRequestContentData';

export type SendNotificationRequestContent = {
  body?: string;
  /** @nullable */
  data?: SendNotificationRequestContentData;
  /** @nullable */
  summary?: string | null;
};
